import {
    SET_CARD
} from "@actions/actionTypes";
import initialStore from "../initialStore";

export default function cardReducer(state = initialStore.cards, action) {
    switch (action.type) {
        case SET_CARD:
            return action.card
        default:
            return state;
    }
}